import { IosPlaceholder } from 'ui/icons';
import { pxToRem } from 'utils/convert';
import {
  notificationAttachmentIos,
  notificationAttachmentWrapper,
  notificationBubble,
  notificationBubbleIosContent,
  notificationBubbleIosContentBody,
  notificationBubbleIosContentBodyMsg,
  notificationBubbleIosContentHeader,
  notificationBubbleIosContentHeaderSender,
  notificationBubbleIosContentHeaderTime,
  notificationContentWrapper,
  notificationPlaceholder,
} from './styles';
import { MAX_CHAR_LIMIT } from '../constants';
import { displayContent, OS, PushPreviewType, TemplateEditViews, truncateText } from '../../common';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { usePushPreviewContext } from '../context/PushPreviewContext';
import { usePreviewWithDataContext } from '../../context/PreviewWithDataContext';
import { PushContentDefinition } from '../../../graphql/types';
import { PreviewActionButtons } from '../PreviewActionButtons';

export const NotificationIos = () => {
  const { liveTemplate } = useEditableFieldsContext();
  const { view } = useQueryParamContext();
  const { messageContentBody, messageContentTitle, messageActionButtons, messageAttachmentUrlIos } =
    usePushPreviewContext();
  const { isDataFeedDataEmpty, isUserDataEmpty } = usePreviewWithDataContext();
  const usePopulatedField =
    view === TemplateEditViews.preview && (!isDataFeedDataEmpty || !isUserDataEmpty);
  const pushData = (liveTemplate?.mediumData || {}) as PushContentDefinition;
  const title = usePopulatedField ? messageContentTitle : pushData.title || '';
  const message = usePopulatedField ? messageContentBody : pushData.message || '';
  const attachmentUrlIos = usePopulatedField
    ? messageAttachmentUrlIos
    : pushData.attachmentUrlIos || '';
  const actionButtons = usePopulatedField ? messageActionButtons : pushData.actionButtons || [];

  return (
    <>
      <div data-test="notification-preview-ios" style={notificationBubble[OS.ios]}>
        <div style={notificationPlaceholder}>
          <IosPlaceholder height={pxToRem(24)} width={pxToRem(24)} />
        </div>
        <div style={notificationBubbleIosContent}>
          <div style={notificationBubbleIosContentHeader}>
            <div style={notificationBubbleIosContentHeaderSender}>{title}</div>
            <div style={notificationBubbleIosContentHeaderTime}>{displayContent.strNow}</div>
          </div>
          <div style={notificationContentWrapper}>
            <div style={notificationBubbleIosContentBody}>
              {/* SMS, Push, & WebPush do not support HTML, so do not use
               * dangerouslySetInnerHTML attr to display content (force text rendering)
               * Email & InApp DO support HTML and should be displayed with
               * dangerouslySetInnerHTML={{ __html: removeScript(content) }} so that HTML
               * renders and scripts are removed prior to rendering
               */}
              <div style={notificationBubbleIosContentBodyMsg}>
                {truncateText(message, MAX_CHAR_LIMIT.ios)}
              </div>
            </div>
            {pushData.attachmentUrlIos && (
              <div style={notificationAttachmentWrapper}>
                <img
                  style={notificationAttachmentIos}
                  src={attachmentUrlIos}
                  alt="IOS Push Image"
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {actionButtons && actionButtons.length > 0 && (
        <PreviewActionButtons
          buttons={actionButtons}
          selectedPreviewType={PushPreviewType.notification}
        />
      )}
    </>
  );
};
